
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mapa-do-site/[slug]",
      function () {
        return require("private-next-pages/mapa-do-site/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mapa-do-site/[slug]"])
      });
    }
  